import type {
  ActivityAvailabilityCriteria,
  GraphQL,
} from '@libs/trip-planner-interfaces';

import { getRecipeQL } from './recipeQL';

export function getTicketRequestQL(
  activityAvailabilityCriteria: ActivityAvailabilityCriteria
): GraphQL.TicketRequestQL {
  return {
    code: activityAvailabilityCriteria.userCriteria.productCode,
    recipe: getRecipeQL({
      userCriteria: activityAvailabilityCriteria.userCriteria.recipe,
      businessCriteria: activityAvailabilityCriteria.businessCriteria,
    }),
    ingredientIndex: activityAvailabilityCriteria.userCriteria.ingredientIndex,
  };
}
